@if (ads) {
  <div class="w-100 d-flex justify-content-center ads-mobile-header">
    @for (add of this.ads; track trackById($index, add)) {
      <div
        [id]="add.pageElementId"
        style="width: {{ add.width ?? 'auto' }};height: {{ add.height ?? 'auto' }}"
      ></div>
    }
  </div>
}
